<template>
    <div class=" 
    text-xl font-poppins
    bg-[#A4EBA2] rounded-b-xl 
    px-[19.76px] py-[5px]">
        <slot></slot>
    </div>
</template>